/* Mrays — phone models shown in the "select your device" picker on the
   pricing section. Keyed by the same brand id used in assets/logo-*.svg.
   Pricing stays generic (see the rates tables) — this list only exists so a
   customer can find their exact model, the way Cashify's picker works.

   PHOTOS: a model's photo is resolved by filename, not by a hand-written map.
   The pattern is  model-BRAND-SLUG.jpg  where SLUG is the model name lowercased
   with "+" becoming "-plus", brackets dropped, and every other run of
   non-alphanumerics collapsed to a hyphen ("Redmi Note 13 Pro+" ->
   redmi-note-13-pro-plus, "Phone (2a)" -> phone-2a). Drop a correctly-named .jpg into assets/ and it
   appears; until then the brand fallback photo is used, so an un-shot model
   never breaks the grid. Add a model by appending a string to the right array. */

var MODELS_BY_BRAND = {
  apple: [
    "iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max", "iPhone 12", "iPhone 12 Mini", "iPhone 12 Pro",
    "iPhone 12 Pro Max", "iPhone 13", "iPhone 13 Mini", "iPhone 13 Pro", "iPhone 13 Pro Max",
    "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max", "iPhone 15", "iPhone 15 Plus",
    "iPhone 15 Pro", "iPhone 15 Pro Max", "iPhone 16", "iPhone 16 Plus", "iPhone 16 Pro",
    "iPhone 16 Pro Max", "iPhone 17", "iPhone 17 Pro", "iPhone 17 Pro Max", "iPhone 5", "iPhone 5c",
    "iPhone 5s", "iPhone 6", "iPhone 6 Plus", "iPhone 6S", "iPhone 6S Plus", "iPhone 7",
    "iPhone 7 Plus", "iPhone 8", "iPhone 8 Plus", "iPhone SE 1st Generation", "iPhone SE 2020",
    "iPhone SE 2022", "iPhone X", "iPhone XR", "iPhone XS", "iPhone XS Max"
  ],
  samsung: [
    "Galaxy A04", "Galaxy A04e", "Galaxy A04s", "Galaxy A05", "Galaxy A05s", "Galaxy A10",
    "Galaxy A10s", "Galaxy A12", "Galaxy A13", "Galaxy A14", "Galaxy A15", "Galaxy A20", "Galaxy A20s",
    "Galaxy A21s", "Galaxy A22", "Galaxy A23", "Galaxy A24", "Galaxy A30", "Galaxy A30s", "Galaxy A31",
    "Galaxy A32", "Galaxy A33", "Galaxy A34", "Galaxy A50", "Galaxy A50s", "Galaxy A51", "Galaxy A52",
    "Galaxy A53", "Galaxy A54", "Galaxy A55", "Galaxy A7 (2018)", "Galaxy A70", "Galaxy A70s",
    "Galaxy A71", "Galaxy A73", "Galaxy F04", "Galaxy F05", "Galaxy F12", "Galaxy F14", "Galaxy F15",
    "Galaxy F22", "Galaxy F23", "Galaxy F36", "Galaxy F41", "Galaxy F55", "Galaxy F62", "Galaxy Fold",
    "Galaxy J4 Plus", "Galaxy J6", "Galaxy J6 Plus", "Galaxy J7 2016", "Galaxy J7 Max",
    "Galaxy J7 Prime", "Galaxy J7 Pro", "Galaxy J8", "Galaxy M01", "Galaxy M01 Core", "Galaxy M10",
    "Galaxy M11", "Galaxy M12", "Galaxy M13", "Galaxy M20", "Galaxy M21", "Galaxy M23", "Galaxy M30",
    "Galaxy M30s", "Galaxy M31", "Galaxy M32", "Galaxy M33", "Galaxy M34", "Galaxy M35", "Galaxy M36",
    "Galaxy M40", "Galaxy M51", "Galaxy M54", "Galaxy Note 10 Lite", "Galaxy Note 10 Plus",
    "Galaxy Note 20 Ultra", "Galaxy Note 9", "Galaxy S10", "Galaxy S10 Plus", "Galaxy S20",
    "Galaxy S20 FE", "Galaxy S20 FE 2022", "Galaxy S20 Plus", "Galaxy S21", "Galaxy S21 FE",
    "Galaxy S21 Plus", "Galaxy S21 Ultra", "Galaxy S22", "Galaxy S22 Plus", "Galaxy S22 Ultra",
    "Galaxy S23", "Galaxy S23 FE", "Galaxy S23 Plus", "Galaxy S23 Ultra", "Galaxy S24",
    "Galaxy S24 FE", "Galaxy S24 Plus", "Galaxy S24 Ultra", "Galaxy S25", "Galaxy S25 Plus",
    "Galaxy S25 Ultra", "Galaxy S8", "Galaxy S8 Plus", "Galaxy S9", "Galaxy Wide 5",
    "Galaxy Xcover 6 Pro", "Galaxy Z Flip", "Galaxy Z Flip 7", "Galaxy Z Flip3", "Galaxy Z Flip4",
    "Galaxy Z Flip5", "Galaxy Z Flip6", "Galaxy Z Fold 7", "Galaxy Z Fold2", "Galaxy Z Fold3",
    "Galaxy Z Fold4", "Galaxy Z Fold5", "Galaxy Z Fold6"
  ],
  xiaomi: [
    "Black Shark 4 Pro", "Mi 10i", "Mi 10T Pro", "Mi 11", "Mi 11 Lite", "Mi 11X", "Mi 4i", "Mi 5",
    "Mi A1", "Mi A2", "Mi A3", "Mi Max", "Mi Max 2", "Mi Note 10", "Redmi 10", "Redmi 10 Prime",
    "Redmi 10A", "Redmi 11 Prime", "Redmi 12", "Redmi 12C", "Redmi 13", "Redmi 13C", "Redmi 14C",
    "Redmi 3S", "Redmi 3S Prime", "Redmi 4", "Redmi 4A", "Redmi 5", "Redmi 5A", "Redmi 6",
    "Redmi 6 pro", "Redmi 6A", "Redmi 7", "Redmi 7A", "Redmi 8", "Redmi 8A", "Redmi 8A Dual",
    "Redmi 9", "Redmi 9 Power", "Redmi 9 Prime", "Redmi 9A", "Redmi 9i", "Redmi A1", "Redmi A1 Plus",
    "Redmi A2", "Redmi A2 Plus", "Redmi K20", "Redmi K20 Pro", "Redmi K30 5G Extreme Edition",
    "Redmi K50i", "Redmi K60", "Redmi Note 10", "Redmi Note 10 Pro", "Redmi Note 10 Pro Max",
    "Redmi Note 10s", "Redmi Note 11", "Redmi Note 11 Pro", "Redmi Note 11 Pro Plus",
    "Redmi Note 11 SE", "Redmi Note 11R", "Redmi Note 11S", "Redmi Note 11T", "Redmi Note 12",
    "Redmi Note 12 Pro", "Redmi Note 12 Pro Plus", "Redmi Note 12 Pro Speed Edition", "Redmi Note 12R",
    "Redmi Note 12s", "Redmi Note 12T Pro", "Redmi Note 13", "Redmi Note 13 Pro", "Redmi Note 3",
    "Redmi Note 4", "Redmi Note 5", "Redmi Note 5 Pro", "Redmi Note 6 Pro", "Redmi Note 7",
    "Redmi Note 7 Pro", "Redmi Note 7S", "Redmi Note 8", "Redmi Note 8 Pro", "Redmi Note 9",
    "Redmi Note 9 Pro", "Redmi Note 9 Pro Max", "Redmi Y1", "Redmi Y1 Lite", "Redmi Y2", "Redmi Y3",
    "Xiaomi 11 Lite NE", "Xiaomi 11i", "Xiaomi 11i HyperCharge", "Xiaomi 11T", "Xiaomi 11T Pro",
    "Xiaomi 12 Pro", "Xiaomi 12X", "Xiaomi 13"
  ],
  vivo: [
    "S1 Pro", "S16", "S16e", "T1 Pro", "T2 Pro", "T2x", "T3 Lite", "T3 Ultra", "T3x", "T4X", "V11",
    "V11 Pro", "V15", "V15 Pro", "V17", "V17 Pro", "V19", "V20", "V20 2021", "V20 Pro", "V21", "V21s",
    "V23", "V23 Pro", "V23e", "V25", "V25 Pro", "V27", "V27 Pro", "V29", "V29 Pro", "V29e", "V30",
    "V30 Pro", "V30e", "V40", "V40 Pro", "V40e", "V5 Plus", "V5s", "V7 Plus", "V9 Pro", "V9 Youth",
    "vivo S1", "vivo T1", "vivo T2", "vivo T3", "vivo V3", "vivo V5", "vivo V7", "vivo V9", "X200 Pro",
    "X21", "X300 Pro", "X60", "X60 Pro", "X60 Pro Plus", "X70 Pro", "X70 Pro Plus", "X80", "X80 Pro",
    "X90", "X90 Pro", "Y02", "Y02A", "Y02s", "Y02T", "Y100", "Y100A", "Y100i", "Y11", "Y11 2023",
    "Y12", "Y12 2023", "Y12s", "Y15 2019", "Y15c", "Y16", "Y17", "Y18e", "Y19", "Y20", "Y200",
    "Y200 Pro", "Y21", "Y21 2021", "Y22 2022", "Y22s", "Y27", "Y27s", "Y28s", "Y30", "Y33e", "Y33s",
    "Y35", "Y35 2022", "Y35 Plus", "Y35m", "Y36", "Y50", "Y51", "Y53", "Y53i", "Y53t", "Y54s", "Y55",
    "Y55L", "Y55s", "Y55s 5G 2023", "Y55T", "Y56", "Y66", "Y69", "Y71", "Y71i", "Y71T", "Y73", "Y73T",
    "Y75", "Y75s", "Y76s", "Y77", "Y77e", "Y77T", "Y78", "Y78t", "Y81", "Y81i", "Y83", "Y83 Pro",
    "Y91", "Y91i", "Y93", "Y95", "Z1 Pro", "Z1x", "Z3X", "Z5i"
  ],
  oneplus: [
    "OnePlus 10 Pro", "OnePlus 10R", "OnePlus 10T", "OnePlus 11", "OnePlus 11R", "OnePlus 12",
    "OnePlus 12R", "OnePlus 13R", "OnePlus 3", "OnePlus 3T", "OnePlus 5", "OnePlus 5T", "OnePlus 6",
    "OnePlus 6T", "OnePlus 7", "OnePlus 7 Pro", "OnePlus 7T", "OnePlus 7T Pro", "OnePlus 8",
    "OnePlus 8 Pro", "OnePlus 8T", "OnePlus 9", "OnePlus 9 Pro", "OnePlus 9R", "OnePlus 9RT",
    "OnePlus Nord", "OnePlus Nord 2", "OnePlus Nord 2T", "OnePlus Nord 3", "OnePlus Nord 4",
    "OnePlus Nord CE", "OnePlus Nord CE 2", "OnePlus Nord CE 2 Lite", "OnePlus Nord CE 3",
    "OnePlus Nord CE 3 Lite", "OnePlus Nord CE4", "OnePlus Nord CE4 Lite"
  ],
  oppo: [
    "A1 Pro", "A11", "A12", "A12s", "A15", "A15s", "A16", "A16e", "A17K", "A18", "A1K", "A1x", "A31",
    "A32", "A33", "A36", "A37", "A38", "A3s", "A5 2020", "A52", "A53", "A53s", "A54", "A56s", "A57",
    "A57e", "A57s", "A58", "A58x", "A59", "A5s", "A71", "A71K", "A72", "A74", "A76", "A77", "A77 2022",
    "A77s", "A78", "A78 4G", "A79", "A83", "A9 2020", "A92", "A96", "A97", "A98", "F1 Plus", "F11",
    "F11 Pro", "F15", "F17", "F17 Pro", "F19 Pro", "F1s", "F21 Pro", "F21s Pro", "F23", "F25 Pro",
    "F27", "F3 Plus", "F5 Youth", "F9 Pro", "Find X8", "K10", "K10 Energy", "K11", "K11x", "Neo 7",
    "OPPO A5", "OPPO A7", "OPPO A8", "OPPO F1", "OPPO F3", "OPPO F5", "OPPO F7", "OPPO F9", "OPPO K9",
    "Reno 10x Zoom", "Reno 2", "Reno 2Z", "Reno A", "Reno Ace", "Reno10", "Reno10 Pro",
    "Reno11 Pro 5g", "Reno12 Pro", "Reno13", "Reno13 Pro", "Reno2 F", "Reno3 Pro", "Reno4",
    "Reno4 Pro", "Reno5 Pro", "Reno6", "Reno7 4G", "Reno8", "Reno8 4G", "Reno8 T", "Reno8T", "Reno9",
    "Reno9 Pro"
  ],
  realme: [
    "realme 1", "realme 10", "realme 10 Pro", "realme 10 Pro Plus", "realme 11 Pro",
    "realme 11 Pro Plus", "realme 12 Pro Plus", "realme 13 Pro Plus", "realme 2", "realme 2 Pro",
    "realme 3", "realme 3 Pro", "realme 3i", "realme 5", "realme 5 Pro", "realme 5i", "realme 5s",
    "realme 6", "realme 6 Pro", "realme 6i", "realme 7", "realme 7 Pro", "realme 7i", "realme 8",
    "realme 8 Pro", "realme 8i", "realme 8s", "realme 9", "realme 9 5G SE", "realme 9 Pro",
    "realme 9 Pro Plus", "realme 9i", "realme C1", "realme C1 2019", "realme C11", "realme C11 2021",
    "realme C12", "realme C15", "realme C15 Qualcomm Edition", "realme C17", "realme C2", "realme C20",
    "realme C20A", "realme C21Y", "realme C25", "realme C25s", "realme C3", "realme C30s",
    "realme C31", "realme C33", "realme C33 2023", "realme C35", "realme C51", "realme C55",
    "realme C65", "realme GT Master Edition", "realme Narzo 10", "realme Narzo 20",
    "realme Narzo 20 Pro", "realme Narzo 20A", "realme Narzo 30", "realme Narzo 30 Pro",
    "realme Narzo 30A", "realme Narzo 50 Pro", "realme Narzo 50A", "realme Narzo 60X",
    "realme Narzo 70", "realme Narzo N53", "realme Narzo N55", "realme Narzo N65", "realme P2 Pro",
    "realme Q3 Pro", "realme Q5", "realme Q5i", "realme U1", "realme V11s", "realme V20", "realme V23",
    "realme V50", "realme X", "realme X2", "realme X2 Pro", "realme X7", "realme X7 Max",
    "realme X7 Pro", "realme X7 Pro Ultra", "realme XT"
  ],
  motorola: [
    "Moto E4", "Moto E4 Plus", "Moto E5", "Moto E5 Plus", "Moto Edge 20", "Moto Edge 30",
    "Moto Edge 30 Fusion", "Moto Edge 40", "Moto Edge 40 Neo", "Moto Edge 50", "Moto Edge 50 Fusion",
    "Moto Edge 50 Pro", "Moto Edge 60 Fusion", "Moto Edge 60 Pro", "Moto G34", "Moto G4",
    "Moto G4 Plus", "Moto G40", "Moto G40 Fusion", "Moto G45", "Moto G5", "Moto G5 Plus", "Moto G54",
    "Moto G5S", "Moto G5s Plus", "Moto G6", "Moto G6 Play", "Moto G6 Plus", "Moto G60", "Moto G64",
    "Moto G85", "Moto M", "Moto Razr 50", "Moto Razr 60", "Moto X4", "Moto Z Play", "Moto Z2 Play",
    "One Fusion Plus", "One Power"
  ],
  nokia: [
    "Nokia 2.1", "Nokia 3.1", "Nokia 3.1 Plus", "Nokia 5.1", "Nokia 5.1 Plus", "Nokia 6.1",
    "Nokia 6.1 Plus", "Nokia 8", "Nokia C02", "Nokia C100", "Nokia C12", "Nokia C12 Plus",
    "Nokia C12 Pro", "Nokia C200", "Nokia C21", "Nokia C210", "Nokia C22", "Nokia C31", "Nokia C32",
    "Nokia G100", "Nokia G11", "Nokia G21", "Nokia G22", "Nokia G400", "Nokia G42", "Nokia G60",
    "Nokia X30"
  ],
  honor: [
    "Honor 10", "Honor 7A", "Honor 7C", "Honor 7S", "Honor 7X", "Honor 8", "Honor 8 Pro", "Honor 8X",
    "Honor 9 Lite", "Honor 9N", "Honor Play", "Honor View 10"
  ],
  asus: [
    "Zenfone Max Pro M1"
  ],
  google: [
    "Pixel 10", "Pixel 10 Pro", "Pixel 10 Pro XL", "Pixel 4a", "Pixel 6", "Pixel 6 Pro", "Pixel 6A",
    "Pixel 7", "Pixel 7 Pro", "Pixel 7A", "Pixel 8", "Pixel 8 Pro", "Pixel 8A", "Pixel 9",
    "Pixel 9 Pro", "Pixel 9 Pro Fold", "Pixel 9 Pro XL", "Pixel 9A", "Pixel XL LTE"
  ],
  poco: [
    "Poco C3", "Poco C40", "Poco C50", "Poco C65", "Poco F1", "Poco F4", "Poco F5", "Poco F5 Pro",
    "Poco F6", "Poco M2", "Poco M2 Pro", "Poco M2 Reloaded", "Poco M3", "Poco M3 Pro", "Poco M4",
    "Poco M4 Pro", "Poco M5s", "Poco M6", "Poco X2", "Poco X3", "Poco X3 Pro", "Poco X4 Pro",
    "Poco X6", "Poco X7"
  ],
  infinix: [
    "Infinix Hot 11 2022", "Infinix Hot 12 Pro", "Infinix Hot 20", "Infinix Hot 20 4G",
    "Infinix Hot 20 Play", "Infinix Hot 20i", "Infinix Hot 20S", "Infinix Hot 30",
    "Infinix Hot 30 Play", "Infinix Hot 40", "Infinix Note 10", "Infinix Note 12",
    "Infinix Note 12 2023", "Infinix Note 12 G96", "Infinix Note 12 Pro", "Infinix Note 12 Pro 4G",
    "Infinix Note 12 VIP", "Infinix Note 12i 2022", "Infinix Smart 6 HD", "Infinix Smart 6 Plus",
    "Infinix Smart 7", "Infinix Smart 7 HD", "Infinix Smart 8", "Infinix Smart 8 HD",
    "Infinix Zero 5G 2023"
  ],
  iqoo: [
    "iQOO 10", "iQOO 13", "iQOO 5 Pro", "iQOO 7", "iQOO 7 Legend", "iQOO 9 SE", "iQOO Neo 6",
    "iQOO Neo 7", "iQOO U1x", "iQOO U3x 4G", "iQOO U5", "iQOO U5e", "iQOO U5x", "iQOO Z8",
    "iQOO Z9 Lite", "iQOO Z9s Pro"
  ],
  nothing: [
    "CMF by Nothing Phone 1", "Phone 1", "Phone 2", "Phone 2a"
  ]
};

var BRAND_LABEL = {
  apple: "Apple", samsung: "Samsung", xiaomi: "Xiaomi", vivo: "vivo",
  oneplus: "OnePlus", oppo: "OPPO", realme: "realme", motorola: "Motorola",
  nokia: "Nokia", honor: "Honor", asus: "Asus", google: "Google",
  poco: "Poco", infinix: "Infinix", iqoo: "iQOO", nothing: "Nothing"
};

/* Fallback studio photo per brand — used for every model that doesn't have
   its own correctly-named photo in assets/ yet. */
var BRAND_PHOTO = {
  apple: "//mrays.in/cdn/shop/t/2/assets/model-apple-fallback.jpg?v=46983565089947495401791224696", samsung: "//mrays.in/cdn/shop/t/2/assets/model-samsung-fallback.jpg?v=79709852378748775101791224695",
  xiaomi: "//mrays.in/cdn/shop/t/2/assets/model-xiaomi-fallback.jpg?v=80408910506271564341791224696", vivo: "//mrays.in/cdn/shop/t/2/assets/model-vivo-fallback.jpg?v=71104451242158499551791224695",
  oneplus: "//mrays.in/cdn/shop/t/2/assets/model-oneplus-fallback.jpg?v=72722983967413604221791224696", oppo: "//mrays.in/cdn/shop/t/2/assets/model-oppo-fallback.jpg?v=146792644003706188351791224697",
  realme: "//mrays.in/cdn/shop/t/2/assets/model-realme-fallback.jpg?v=83003554880357835761791224697", motorola: "//mrays.in/cdn/shop/t/2/assets/model-motorola-fallback.jpg?v=67986509947950921131791224697",
  nokia: "//mrays.in/cdn/shop/t/2/assets/model-nokia-fallback.jpg?v=171088536645520404951791224697", honor: "//mrays.in/cdn/shop/t/2/assets/model-honor-fallback.jpg?v=154115888922608158391791224700",
  asus: "//mrays.in/cdn/shop/t/2/assets/model-asus-fallback.jpg?v=135233432555876925811791224697", google: "//mrays.in/cdn/shop/t/2/assets/model-google-fallback.jpg?v=85669602682765387931791224696",
  poco: "//mrays.in/cdn/shop/t/2/assets/model-poco-fallback.jpg?v=116730510052513216771791224696", infinix: "//mrays.in/cdn/shop/t/2/assets/model-infinix-fallback.jpg?v=80352344763699234621791224696",
  iqoo: "//mrays.in/cdn/shop/t/2/assets/model-iqoo-fallback.jpg?v=105793335134520761561791224697", nothing: "//mrays.in/cdn/shop/t/2/assets/model-nothing-fallback.jpg?v=8369405783598938881791224696"
};

/* Every theme asset lives in the same CDN directory, so one known asset URL
   gives us the base every model photo can be built from — that's what lets a
   new model be a one-line addition above plus a correctly-named upload. */
var ASSET_BASE = "//mrays.in/cdn/shop/t/2/assets/model-apple-iphone-13.jpg?v=29936043343975788441791224696".split('?')[0].replace(/[^/]+$/, '');

/* Shopify's ?v= hash is what makes a replaced asset actually reach browsers —
   the CDN caches these files for a year, so a URL without it keeps serving the
   old bytes long after the upload. Stripping it to append ?width= is why
   re-uploaded photos appeared not to change. Each asset has its own hash and
   JS can't know 790 of them, so one sentinel photo's hash stands in for the
   set: the photos are rebuilt and uploaded together, so it moves when they do.
   A photo replaced on its own won't bust this — re-save the sentinel too. */
var PHOTO_VER = "//mrays.in/cdn/shop/t/2/assets/model-apple-iphone-13.jpg?v=29936043343975788441791224696".split('?')[1] || '';

function modelSlug(model) {
  return model
    .toLowerCase()
    .replace(/\+/g, '-plus')   /* "S24+" and "S24" are different phones — dropping
                                  the plus collapsed 12 pairs onto one filename */
    .replace(/[()]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function modelPhoto(brand, model) {
  return ASSET_BASE + 'model-' + brand + '-' + modelSlug(model) + '.jpg' +
         (PHOTO_VER ? '?' + PHOTO_VER : '');
}

/* Attached to every model image so a model whose photo hasn't been shot yet
   falls back to the brand photo instead of rendering a broken image. */
function modelPhotoFallback(img, brand) {
  if (img.dataset.fellBack) return;
  img.dataset.fellBack = '1';
  img.removeAttribute('srcset');
  img.src = BRAND_PHOTO[brand];
}
